import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { CommissionCashbackMutationKeys } from '../../../keys'
import {
	CreateCommissionCashbackRequest,
	CreateCommissionCashbackResponse,
} from '../../../type'
import { createCommissionCashback } from '../../services'

interface CreateCommissionCashbackParams {
	payload: CreateCommissionCashbackRequest
}

export default function useMutationCreateCommission(
	props?: UseBaseMutationOptions<
		CreateCommissionCashbackResponse,
		CreateCommissionCashbackParams
	>,
) {
	return useMutation({
		mutationKey: [CommissionCashbackMutationKeys.CreateCommissionCashback],
		mutationFn: (params) => createCommissionCashback(params.payload),
		...props,
	})
}
